import React, { useEffect } from "react";
import Select from "react-select";

type Props = {
	value: string,
	isDisabled?: boolean,
	updateConfig: Function
}

const PaidType = (props: Props) => {
	const metrics = [
		{label: "All", value: ""},
		{label: "Paid", value: "paid"},
		{label: "Free", value: "free"},
	];

	useEffect(() => {
		if (props.isDisabled === true && props.value !== "") {
			props.updateConfig(['paid_type'], [""]);
		}
	}, [props.isDisabled]);
	
	return (
		<div className="form-group">
			<label htmlFor="metricType">Story type:</label>
			<Select
				id="metricType"
				className="basic-single"
				classNamePrefix="so-select-metric-type"
				value={props.value ? metrics.find(item => item.value === props.value) : {label: "All", value: ""}}
				options={metrics}
				isDisabled={props.isDisabled}
				onChange={e => props.updateConfig(['paid_type'], [e!.value])}
				menuPortalTarget={document.body}
				styles={{menuPortal: base => ({...base, zIndex: 9999})}}
			/>
		</div>
	);
};

export default PaidType;
